<template>
  <div class="staff-table-wrap">
    <el-table
      class="staff-table"
      :data="tableData"
      height="100%"
      :header-cell-style="headerCellStyle"
      :cell-style="tableCellStyle"
      :row-class-name="rowClassName"
    >
      <el-table-column prop="aftersaleName" label="售后人员" min-width="64" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.aftersaleName || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="staffBizStatus" label="状态" min-width="56" align="center">
        <template slot-scope="scope">
          <span class="biz-tag" :class="scope.row.staffBizStatus === 'BUSY' ? 'busy' : 'idle'">
            {{ staffBizLabel(scope.row.staffBizStatus) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="receiveTotal" label="接单" min-width="48" align="center" />
    </el-table>
  </div>
</template>

<script>
import { staffBizLabel } from "@/common/js/workOrderDict";

export default {
  name: "staffRankTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headerCellStyle: {
        background: "rgba(0, 100, 140, 0.75)",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "12px",
        textAlign: "center",
        padding: "6px 0",
        borderBottom: "1px solid rgba(0, 229, 255, 0.45)",
      },
    };
  },
  methods: {
    staffBizLabel,
    tableCellStyle() {
      return {
        background: "transparent",
        color: "#e8f4ff",
        textAlign: "center",
        padding: "4px 0",
        borderBottom: "1px solid rgba(0, 180, 220, 0.15)",
        fontSize: "12px",
      };
    },
    rowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? "row-even" : "row-odd";
    },
  },
};
</script>

<style scoped lang="scss">
.staff-table-wrap {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.staff-table {
  width: 100%;
  height: 100%;
  background: transparent !important;
}

.biz-tag {
  display: inline-block;
  padding: 1px 6px;
  font-size: 11px;
  border: 1px solid;

  &.busy {
    color: #ff5a5a;
    border-color: rgba(255, 90, 90, 0.55);
    background: rgba(255, 90, 90, 0.15);
  }
  &.idle {
    color: #2ecc71;
    border-color: rgba(46, 204, 113, 0.55);
    background: rgba(46, 204, 113, 0.15);
  }
}

::v-deep .el-table {
  background: transparent;
  color: #e8f4ff;

  &::before {
    background: transparent;
  }

  tr,
  th.el-table__cell {
    background: transparent;
  }

  .el-table__header-wrapper th.el-table__cell {
    background: rgba(0, 100, 140, 0.75) !important;
  }

  .row-even td.el-table__cell {
    background: rgba(0, 60, 100, 0.18) !important;
  }
  .row-odd td.el-table__cell {
    background: transparent !important;
  }

  .el-table__body tr:hover > td.el-table__cell {
    background: rgba(0, 180, 220, 0.18) !important;
  }

  td.el-table__cell,
  th.el-table__cell {
    border-color: rgba(0, 180, 220, 0.15) !important;
  }

  .el-table__empty-text {
    color: #8eb6d0;
  }
}
</style>
